import React, { useEffect, useState } from "react";

// Antd
import { PlusOutlined, WhatsAppOutlined, HeartFilled } from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Input,
  List,
  Radio,
  Select,
  Spin,
  Tag,
  Tooltip,
  Modal,
  message,
} from "antd";
import { Link } from "react-router-dom";

// API
import {
  addCourseToWishList,
  getAllCoursesByRole,
  getUserById,
  getUsersCourses,
  removeCourseFromWishList,
  getWishListCourcesByUser,
  editCourse,
  getAllUsers,
} from "../../../Constants/Api/functions/function";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { setAllCources } from "../../../Reducers/allCourcesReducer";

// Styles
import "./style.scss";

import AddCource from "./AddCource";
import { DEFAULT_USER_PROFILE_IMAGE } from "../../../Constants/Api/azure/azure";
import { setUsersCources } from "../../../Reducers/usersCourcesReducer";
import { setUserProfile } from "../../../Reducers/userProfileReducer";

const PromoCountdown = ({ endDate }) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!endDate) return;
    
    const calculateTimeLeft = () => {
      const difference = +new Date(endDate) - +new Date();
      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        return `Ends in ${days}d ${hours}h ${minutes}m`;
      }
      return 'Promotion Ended';
    };

    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 60000); // update every minute

    return () => clearInterval(timer);
  }, [endDate]);

  if (!timeLeft) return null;

  return (
    <div style={{ color: '#ff4d4f', fontWeight: 'bold', fontSize: '12px', marginTop: '4px' }}>
      ⏱ {timeLeft}
    </div>
  );
};

const Cources = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAddCourseOpen, setIsAddCourseOpen] = useState(false);
  const [radioValue, setRadioValue] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const allCources = useSelector((state) => state.allCources.allCources);

  const filteredCources = React.useMemo(() => {
    if (!allCources) return [];
    if (userProfile?.role === "coordinator") {
      return allCources.filter((c) => c.coordinatorId && String(c.coordinatorId) === String(userProfile.id));
    }
    if (userProfile?.role === "student") {
      return allCources.filter((c) => c.isAppearOnHome === true || c.isAppearOnHome === 1 || c.isAppearOnHome === "true");
    }
    return allCources;
  }, [allCources, userProfile]);

  const [userCources, setUserCources] = useState();
  const [data, setData] = useState();
  const [coursesData, setCoursesData] = useState();
  const [wishlistCourses, setWishlistCourses] = useState([]);
  const dispatch = useDispatch();

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedCoordinatorId, setSelectedCoordinatorId] = useState(undefined);
  const [coordinators, setCoordinators] = useState([]);
  const [instructors, setInstructors] = useState([]);
  const [isAssigning, setIsAssigning] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      if (userProfile?.role === "superadmin" || userProfile?.role === "admin") {
        try {
          const users = await getAllUsers(2); // Center 2
          if (users) {
            const filteredCoordinators = users.filter((u) => u.role === "coordinator");
            setCoordinators(filteredCoordinators);
            const filteredInstructors = users.filter((u) => u.role === "instructor");
            setInstructors(filteredInstructors);
          }
        } catch (error) {
          console.error("Failed fetching users:", error);
        }
      }
    };
    fetchUsers();
  }, [userProfile]);

  const handleAssignCoordinator = async () => {
    setIsAssigning(true);
    try {
      const selectedCoord = coordinators.find((c) => c.id === selectedCoordinatorId);
      const response = await editCourse({
        id: selectedCourseId,
        coordinatorId: selectedCoordinatorId || null,
        coordinatorName: selectedCoord ? selectedCoord.name : null,
        coordinatorWhatsApp: selectedCoord ? selectedCoord.contactNumber : null,
      });
      if (response && response.status === 200) {
        message.success("Coordinator assigned successfully");
        setShowAssignModal(false);
        await hadleGetCources();
      } else {
        message.error("Failed to assign coordinator");
      }
    } catch (error) {
      console.error("handleAssignCoordinator error:", error);
      message.error("Failed to assign coordinator");
    } finally {
      setIsAssigning(false);
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const sortedData = [...data].sort((a, b) => {
        return a?.orderNumber - b?.orderNumber;
      });
      setCoursesData(
        sortedData.map((item) => {
          return {
            id: item?.id,
            title: item?.name,
            description: item?.description,
            isPublished: item?.isPublished,
            thumbnail: item?.coverImage,
            price: item?.price,
            authorName: item?.createdBy?.name,
            authorImage: item?.createdBy?.profileImage,
            orderNumber: item?.orderNumber,
            whatsappGroupLink: item?.whatsappGroupLink,
            tags: item?.tags,
            duration: item?.duration,
            status: item?.status,
            instructorId: item?.instructorId,
            instructorName: item?.instructorName,
            coordinatorId: item?.coordinatorId,
            coordinatorName: item?.coordinatorName,
            promoPrice: item?.promoPrice,
            promoStartDate: item?.promoStartDate,
            promoEndDate: item?.promoEndDate,
            isPromoActive: item?.isPromoActive,
            alumniDiscount: item?.alumniDiscount,
            prerequisiteCourseIds: item?.prerequisiteCourseIds,
          };
        })
      );
    } else if (data && data.length === 0) {
      // Handle empty array case
      setCoursesData([]);
    }
  }, [data, userCources]);

  // Fetch wishlist courses
  useEffect(() => {
    if (userProfile?.id && userProfile?.role !== "superadmin" && userProfile?.role !== "admin") {
      handleGetWishlistCourses();
    }
  }, [userProfile?.id]);

  useEffect(() => {
    if (userProfile?.role !== "superadmin" && userProfile?.role !== "admin") {
      handleGetUserCources();
    }
  }, []);

  useEffect(() => {
    if (userProfile) {
      hadleGetCources();
    }
  }, [userProfile]);

  // Function to fetch wishlist courses
  const handleGetWishlistCourses = async () => {
    try {
      const response = await getWishListCourcesByUser(userProfile.id);
      if (response && Array.isArray(response)) {
        setWishlistCourses(response);
      }
    } catch (error) {
      console.error("handleGetWishlistCourses error:", error);
    }
  };

  const applyRadioFilter = (radio, sourceList = filteredCources) => {
    if (!sourceList) return;
    const isAdmin = userProfile?.role === "superadmin" || userProfile?.role === "admin";

    if (radio === 1) {
      if (isAdmin) {
        setData([...sourceList]);
      } else {
        const ongoingCourses = sourceList.filter((course) => {
          return course?.status !== "completed";
        });
        setData(ongoingCourses);
      }
    } else if (radio === 3) {
      const filteredData = sourceList.filter((item) => {
        const price =
          typeof item?.price === "string"
            ? parseFloat(item.price)
            : item?.price || 0;
        return price === 0;
      });
      setData(filteredData);
    } else if (radio === 4) {
      const completedCourses = sourceList.filter((course) => {
        return course?.status === "completed";
      });
      setData(completedCourses);
    } else if (radio === 5) {
      const publishedCourses = sourceList.filter((course) => {
        return course?.isPublished === 1 || course?.isPublished === true;
      });
      setData(publishedCourses);
    } else if (radio === 6) {
      const notPublishedCourses = sourceList.filter((course) => {
        return !course?.isPublished || course?.isPublished === 0;
      });
      setData(notPublishedCourses);
    } else {
      const filteredData = sourceList.filter((item) => {
        return userCources?.find((course) => course?.id === item?.id);
      });
      setData(filteredData);
    }
  };

  // Sync filteredCources with data when filteredCources changes and we're on "All Courses" view
  useEffect(() => {
    if (
      filteredCources &&
      filteredCources.length > 0 &&
      userProfile &&
      !searchQuery
    ) {
      applyRadioFilter(radioValue, filteredCources);
    }
  }, [filteredCources, radioValue, userProfile, searchQuery]);

  const hadleGetCources = async () => {
    setIsLoading(true);
    try {
      if (userProfile) {
        let response = await getAllCoursesByRole(
          userProfile.role,
          userProfile.id
        );
        if (response && Array.isArray(response)) {
          if (userProfile.role === "superadmin" || userProfile.role === "admin") {
            // Admins see all courses in All Courses view
            setData([...response]);
          } else if (userProfile.role === "coordinator") {
            const coordCourses = response.filter((c) => c.coordinatorId && String(c.coordinatorId) === String(userProfile.id));
            setData([...coordCourses]);
          } else if (userProfile.role === "student") {
            const ongoingCourses = response.filter((course) => {
              const isAppear = course?.isAppearOnHome === true || course?.isAppearOnHome === 1 || course?.isAppearOnHome === "true";
              return course?.status !== "completed" && isAppear;
            });
            setData([...ongoingCourses]);
          } else {
            const ongoingCourses = response.filter((course) => {
              return course?.status !== "completed";
            });
            setData([...ongoingCourses]);
          }
          dispatch(setAllCources([...response]));
        }
      }
    } catch (error) {
      console.error("hadleGetCources error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetUserCources = async () => {
    setIsLoading(true);
    try {
      const userCources = await getUsersCourses(userProfile?.id);
      setUserCources(userCources);
      dispatch(setUsersCources(userCources));
    } catch (error) {
      console.error("handleGetUserCources", error);
    }
    setIsLoading(false);
  };

  const onChangeRadio = (e) => {
    const newRadio = e.target.value;
    setRadioValue(newRadio);
    setSearchQuery("");
    applyRadioFilter(newRadio, filteredCources);
  };

  const handleCourseSearch = (queryText) => {
    const val = (queryText || "").trim().toLowerCase();
    setSearchQuery(queryText || "");

    if (!val) {
      applyRadioFilter(radioValue, filteredCources);
      return;
    }

    const isAdmin = userProfile?.role === "superadmin" || userProfile?.role === "admin";

    // Search across ALL courses in filteredCources (published, unpublished, completed, ongoing)
    const filteredData = filteredCources?.filter((item) => {
      const nameMatch = item?.name?.toLowerCase().includes(val);
      const codeMatch = item?.courseid ? item.courseid.toLowerCase().includes(val) : false;
      const tagsMatch = item?.tags ? item.tags.toLowerCase().includes(val) : false;
      const descMatch = item?.description ? item.description.toLowerCase().includes(val) : false;
      const authorMatch = item?.createdBy?.name ? item.createdBy.name.toLowerCase().includes(val) : false;

      const isPublished = item?.isPublished === 1 || item?.isPublished === true;
      const publishMatch =
        (val === "published" && isPublished) ||
        ((val === "not published" || val === "unpublished" || val === "draft") && !isPublished);

      const statusMatch = (item?.status || "ongoing").toLowerCase().includes(val);

      return nameMatch || codeMatch || tagsMatch || descMatch || authorMatch || (isAdmin && (publishMatch || statusMatch));
    });

    setData(filteredData || []);
  };

  const filterBytags = (value) => {
    if (value === "All") {
      setData(filteredCources);
    } else {
      const filteredData = data?.filter((item) => {
        const tagsArray = item?.tags?.split(",");
        return tagsArray?.find((tag) => tag === value);
      });

      setData(filteredData);
    }
  };

  const hnadlegetUserById = async (user) => {
    try {
      if (!user || !user.id) {
        return;
      }
      const response = await getUserById(user.id);
      if (response && response.id) {
        dispatch(setUserProfile(response));
        localStorage.setItem("digital-academy-user", JSON.stringify(response));
      }
    } catch (error) {
      console.log("handlegetUserById -> error", error);
    }
  };

  const renderTags = (tags) => {
    return tags?.split(",").map((tag, index) => {
      if (tag === "VideoTutorials") {
        return (
          <Tag key={index} color="blue">
            Video Tutorials
          </Tag>
        );
      } else if (tag === "Exams") {
        return (
          <Tag key={index} color="blue">
            Exams
          </Tag>
        );
      } else if (tag === "TrainingAndCourses") {
        return (
          <Tag key={index} color="blue">
            Training and Courses
          </Tag>
        );
      } else if (tag === "News") {
        return (
          <Tag key={index} color="blue">
            News
          </Tag>
        );
      } else if (tag === "Seminar") {
        return (
          <Tag key={index} color="blue">
            Seminar
          </Tag>
        );
      }
      return null;
    });
  };

  // const isCourseInWishList = (courseId) => {
  //     const userWishList = userProfile?.courseWishlist;
  //     const wishlistIds = userWishList?.split(',');
  //     wishlistIds?.pop();

  //     return wishlistIds?.find((id) => id === courseId);
  // }

  // UPDATED: Check if course is in wishlist using the fetched wishlist array
  const isCourseInWishList = (courseId) => {
    return wishlistCourses?.some(
      (course) => course.id === courseId || course.courseid === courseId
    );
  };

  const isCourseBought = (courseId) => {
    let res = false;
    res = userCources?.find((course) => course?.id === courseId);

    if (allCources?.find((course) => course?.id === courseId)?.price === 0) {
      res = true;
    }

    return res;
  };

  const handleAddOrRemoveFromWishList = async (courseId) => {
    setIsLoading(true);
    try {
      const isInWishList = isCourseInWishList(courseId);
      if (isInWishList) {
        const res = await removeCourseFromWishList(userProfile.id, courseId);
        if (res) {
          await hnadlegetUserById(userProfile);
          await hadleGetCources();
          // NEW: Refresh wishlist after removal
          await handleGetWishlistCourses();
        }
      } else {
        const res = await addCourseToWishList(userProfile.id, courseId);
        if (res) {
          await hnadlegetUserById(userProfile);
          await hadleGetCources();
          // NEW: Refresh wishlist after addition
          await handleGetWishlistCourses();
        }
      }
    } catch (error) {
      console.log(error);
    }

    setIsLoading(false);
  };

  return (
    <div className="cources">
      <div className="cources-action-buttons">
        <div className="filters">
          <div className="filter-search">
            <h2>All Courses</h2>
            <div className="filter-inputs">
              <AutoComplete
                popupMatchSelectWidth={340}
                options={filteredCources?.map((item) => {
                  const isPub = item?.isPublished === 1 || item?.isPublished === true;
                  const pubBadge = (userProfile?.role === "superadmin" || userProfile?.role === "admin")
                    ? ` • ${isPub ? "Published" : "Not Published"}`
                    : "";
                  const codeText = item?.courseid ? ` (${item.courseid})` : "";
                  return {
                    value: item.name,
                    label: `${item.name}${codeText}${pubBadge}`,
                  };
                })}
                filterOption={(inputValue, option) =>
                  option?.label?.toLowerCase().includes(inputValue.toLowerCase())
                }
                size="large"
                onSelect={(value) => handleCourseSearch(value)}
              >
                <Input.Search
                  size="large"
                  placeholder="Search all courses by title, code or status..."
                  allowClear
                  enterButton
                  value={searchQuery}
                  onSearch={(value) => handleCourseSearch(value)}
                  onChange={(e) => handleCourseSearch(e.target.value)}
                />
              </AutoComplete>
            </div>
          </div>
          <div className="radio-buttons">
            <Radio.Group onChange={onChangeRadio} value={radioValue}>
              <Radio value={1}>All Courses</Radio>
              {userProfile?.role === "student" && <Radio value={2}>My Courses</Radio>}
              <Radio value={3}>Free Courses</Radio>
              {(userProfile?.role === "superadmin" || userProfile?.role === "admin") && (
                <>
                  <Radio value={5}>Published</Radio>
                  <Radio value={6}>Not Published</Radio>
                  <Radio value={4}>Completed</Radio>
                </>
              )}
            </Radio.Group>
          </div>

          <div className="radio-buttons">
            <Select
              placeholder="Filter by tags"
              style={{
                minWidth: "150px",
              }}
              onChange={(value) => filterBytags(value)}
            >
              <Select.Option value={"All"}>All</Select.Option>
              <Select.Option value={"VideoTutorials"}>
                Video Tutorials
              </Select.Option>
              <Select.Option value={"Exams"}>Exams</Select.Option>
              <Select.Option value={"TrainingAndCourses"}>
                Training and Courses
              </Select.Option>
              <Select.Option value={"News"}>News</Select.Option>
              <Select.Option value={"Seminar"}>Seminar</Select.Option>
            </Select>
          </div>
        </div>
        {(userProfile?.role === "superadmin" || userProfile?.role === "admin" || userProfile?.role === "coordinator") && (
          <Button type="primary" onClick={() => setIsAddCourseOpen(true)}>
            <PlusOutlined />
            Add Cource
          </Button>
        )}
      </div>
      <Spin spinning={isLoading} tip="Loading Courses...">
        <div className="cources-body">
          <Spin tip="Loading..." spinning={isLoading}>
            <List
              grid={{
                gutter: 30,
                xs: 1,
                sm: 1,
                md: 2,
                lg: 2,
                xl: 3,
                xxl: 4,
              }}
              dataSource={coursesData}
              renderItem={(item) => (
                <List.Item>
                  <div className="course-card">
                    <div className="card-image-container">
                      <img
                        src={
                          item?.thumbnail
                            ? item?.thumbnail
                            : require("./1695793881259.jpeg")
                        }
                        alt=""
                      />
                      <div className="cource-card-header-buttons">
                        {userProfile?.role === "student" ? (
                          <>
                            {!isCourseBought(item?.id) && (
                              <div
                                className={
                                  isCourseInWishList(item.id)
                                    ? "wishlist-In"
                                    : "wishlist-Out"
                                }
                              >
                                <Tooltip
                                  title={
                                    isCourseInWishList(item.id)
                                      ? "Remove from wishlist"
                                      : "Request to follow this Course | මෙම පාඨමාලාව හැදෑරීමට ඉල්ලුම් කිරීමට කැමැත්තෙමි."
                                  }
                                >
                                  <HeartFilled
                                    // UPDATED: Apply red color when in wishlist
                                    style={{
                                      color: isCourseInWishList(item?.id)
                                        ? "#ff4d4f"
                                        : "#d9d9d9",
                                      fontSize: "20px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      handleAddOrRemoveFromWishList(item.id)
                                    }
                                  />
                                </Tooltip>
                              </div>
                            )}
                            <div
                              className="duration"
                              style={{
                                backgroundColor:
                                  item?.status === "completed" ? "#4CAF50" : "#FF9800",
                              }}
                            >
                              <p>
                                {item?.status === "completed" ? "Completed" : "Ongoing"}
                              </p>
                            </div>
                          </>
                        ) : (
                          <div
                            className="duration"
                            style={{
                              backgroundColor: item?.isPublished
                                ? "#4CAF50"
                                : "#f44336",
                            }}
                          >
                            <p>
                              {item?.isPublished
                                ? "Published"
                                : "Not Published"}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-description">
                        <div className="price" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px', width: '100%' }}>
                          {item?.price === 0 ? (
                            <span className="free-text" style={{ fontSize: '1.25rem', fontWeight: '700', color: '#52c41a' }}>Free</span>
                          ) : (
                            <>
                              {item?.isPromoActive && item?.promoStartDate && item?.promoEndDate && new Date() >= new Date(item.promoStartDate) && new Date() <= new Date(item.promoEndDate) ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', flexWrap: 'wrap' }}>
                                    <span style={{ color: '#ff4d4f', fontSize: '1.25rem', fontWeight: '700', whiteSpace: 'nowrap' }}>{Number(item?.promoPrice || 0).toLocaleString()} LKR</span>
                                    <span style={{ textDecoration: 'line-through', color: '#8c8c8c', fontSize: '0.9rem', whiteSpace: 'nowrap' }}>{Number(item?.price || 0).toLocaleString()} LKR</span>
                                  </div>
                                  <PromoCountdown endDate={item.promoEndDate} />
                                </div>
                              ) : (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                  <span style={{ fontSize: '1.25rem', fontWeight: '700', color: '#1f1f1f', whiteSpace: 'nowrap' }}>{Number(item?.price || 0).toLocaleString()} LKR</span>
                                  {item?.alumniDiscount > 0 && item?.prerequisiteCourseIds && (() => { try { const ids = typeof item.prerequisiteCourseIds === 'string' ? JSON.parse(item.prerequisiteCourseIds) : item.prerequisiteCourseIds; return Array.isArray(ids) && ids.length > 0; } catch { return false; } })() && (
                                    <span style={{ color: '#52c41a', fontSize: '0.85rem', fontWeight: '600', whiteSpace: 'nowrap' }}>
                                      Alumni Price: {Number((item.price || 0) - (item.alumniDiscount || 0)).toLocaleString()} LKR
                                    </span>
                                  )}
                                </div>
                              )}
                            </>
                          )}
                        </div>

                        <div className="author">
                          <img
                            src={
                              item?.authorImage
                                ? item?.authorImage
                                : DEFAULT_USER_PROFILE_IMAGE
                            }
                            alt=""
                          />
                          <h3>{item?.authorName}</h3>
                        </div>
                      </div>

                      <h3 className="title">{item?.title}</h3>

                      {item?.duration && (
                        <div style={{ marginBottom: "10px", fontSize: "13px", fontWeight: "600", color: "#666" }}>
                          Duration: {item.duration}
                        </div>
                      )}

                      <div className="tags">{renderTags(item?.tags)}</div>

                      {(() => {
                        const instructorName = item?.instructorNames || item?.instructorName || instructors.find(
                          (inst) => inst.id === item?.instructorId
                        )?.name;
                        if (instructorName) {
                          return (
                            <div
                              className="instructor-badge"
                              style={{
                                marginTop: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "4px 8px",
                                background: "rgba(24, 144, 255, 0.05)",
                                border: "1px solid rgba(24, 144, 255, 0.15)",
                                borderRadius: "6px",
                                width: "fit-content",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "11px",
                                  fontWeight: "bold",
                                  color: "#1890ff",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Instructor:
                              </span>
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#1f1f1f",
                                  fontWeight: 500,
                                }}
                              >
                                {instructorName}
                              </span>
                            </div>
                          );
                        }
                        return null;
                      })()}

                      {(() => {
                        const coordinatorName = item?.coordinatorName || coordinators.find(
                          (c) => c.id === item?.coordinatorId
                        )?.name;
                        if (coordinatorName) {
                          return (
                            <div
                              className="coordinator-badge"
                              style={{
                                marginTop: "8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "4px 8px",
                                background: "rgba(114, 46, 209, 0.05)",
                                border: "1px solid rgba(114, 46, 209, 0.15)",
                                borderRadius: "6px",
                                width: "fit-content",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "11px",
                                  fontWeight: "bold",
                                  color: "#722ed1",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Coordinator:
                              </span>
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#1f1f1f",
                                  fontWeight: 500,
                                }}
                              >
                                {coordinatorName}
                              </span>
                            </div>
                          );
                        }
                        return null;
                      })()}
                    </div>

                    <div className="card-footer">
                      <div className="button-continer">
                        <>
                          {userProfile?.role === "superadmin" || userProfile?.role === "admin" || userProfile?.role === "coordinator" || userProfile?.role === "instructor" ? (
                            <div className="admin-actions">
                              <Link
                                className="enroll-now"
                                to={`/dashboard/cources/${item.id}`}
                              >
                                <Button type="link">View</Button>
                              </Link>
                              {(userProfile?.role === "superadmin" || userProfile?.role === "admin") && (
                                <Button
                                  type="link"
                                  style={{ color: "#1890ff" }}
                                  onClick={() => {
                                    setSelectedCourseId(item.id);
                                    setSelectedCoordinatorId(item.coordinatorId || undefined);
                                    setShowAssignModal(true);
                                  }}
                                >
                                  Assign Coordinator
                                </Button>
                              )}
                            </div>
                          ) : (
                            <Link
                              className="enroll-now"
                              to={`/dashboard/cources/${item.id}`}
                            >
                              <Button type="link">
                                {userCources?.find(
                                  (course) => course?.id === item?.id
                                )
                                  ? "Continue"
                                  : "Enroll Now"}
                              </Button>
                            </Link>
                          )}
                        </>
                        <>
                          {item?.whatsappGroupLink && (
                            <a
                              href={item?.whatsappGroupLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <Button
                                type="primary"
                                style={{
                                  backgroundColor: "#25d366",
                                }}
                              >
                                <WhatsAppOutlined />
                                Join Whatsapp Group
                              </Button>
                            </a>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                </List.Item>
              )}
            />
          </Spin>
        </div>
      </Spin>

      <Modal
        title="Assign Coordinator to Course"
        open={showAssignModal}
        onOk={handleAssignCoordinator}
        confirmLoading={isAssigning}
        onCancel={() => setShowAssignModal(false)}
        okText="Assign"
        cancelText="Cancel"
        destroyOnClose
      >
        <div style={{ padding: "16px 0" }}>
          <p style={{ marginBottom: "8px" }}>Select a coordinator to assign to this course:</p>
          <Select
            placeholder="Select Coordinator"
            style={{ width: "100%" }}
            value={selectedCoordinatorId}
            onChange={(val) => setSelectedCoordinatorId(val)}
            allowClear
            showSearch
            optionFilterProp="children"
          >
            {coordinators.map((coord) => (
              <Select.Option key={coord.id} value={coord.id}>
                {coord.name} ({coord.email})
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>

      <AddCource
        isOpen={isAddCourseOpen}
        setOpen={setIsAddCourseOpen}
        hadleGetCources={hadleGetCources}
      />
    </div>
  );
};
export default Cources;
